import AdminRolesAndPermissions from './AdminRolesAndPermissions.jsx';
import { connect } from 'react-redux';

import { Map } from 'immutable';

import { request as getPermissions } from '../../modules/permissions/actions/get';
import { request as getRoles } from '../../modules/roles/actions/get';
import { request as deleteRequest } from '../../modules/roles/actions/delete';
import { request as updateRequest } from '../../modules/roles/actions/update';

import decorate from '../../utils/decorate';

function mapStateToProps(state) {
    return {
        roles: state.roles.getIn([ 'items' ], Map()).filter(role => (
                state.roles.getIn([ 'collections', 'staff' ]).contains(role.get('id'))
        )),
        permissions: state.permissions.getIn([ 'items' ], Map()),
        loading: (
            state.roles.get('state') === 'IN_PROGRESS' ||
            state.permissions.get('state') === 'IN_PROGRESS'
        )
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onPermissionsGetRequest: () => dispatch(getPermissions()),
        onRolesGetRequest: () => dispatch(getRoles()),
        onRoleDeleteRequest: id => dispatch(deleteRequest(id)),
        onRoleUpdateRequest: roleData => dispatch(updateRequest(roleData))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AdminRolesAndPermissions
);
